import { useQuery } from "@apollo/react-hooks";

import { AgreementDocuments } from "../types";
import getAgreementsDocumentsByPerson from "../graph-ql/getAgreementsDocumentsByPerson.graphql";

const useQueryGetAgreementsDocumentsByPerson = (personKey: string) =>
  useQuery<{ getAgreementsDocumentsByPerson: AgreementDocuments[] }>(
    getAgreementsDocumentsByPerson,
    {
      variables: { personKey },
    },
  );

export default useQueryGetAgreementsDocumentsByPerson;
